import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'toWaterPointIcon',
  standalone: true
})
export class ToWaterPointIconPipe implements PipeTransform {
  constructor() {
  }
  
  public transform(value?: string): string {
    switch (value?.toLocaleLowerCase()) {
      case "low_alert":
        return "icons/water-point-low-alert-icon.svg"
      case "low_warning":
        return "icons/water-point-low-warning-icon.svg"
      default:
        return "icons/water-point-icon-color.svg"
    }
  }
}